import { exec, getApiToken } from '@src/apis/reware/utils';
import type {
  GetVitalElementsQuery,
  GetVitalElementsQueryVariables,
} from '@src/types/__generated/rewareRestUserTypes';

const gql = String.raw;

export interface FetchVitalElementsArgs {
  partnerCode: string;
  token: string;
}

/**
 * Fetches vital elements for a partner using the getVitalElements query.
 * Returns an array of vital element tag strings (e.g., ["color", "size", "material"]).
 */
export const fetchVitalElements = async ({ partnerCode, token }: FetchVitalElementsArgs): Promise<string[]> => {
  const apiToken = await getApiToken(token);

  const query = gql`
    query getVitalElements(
      $token: String!
      $partnerCode: String
    ) {
      restUser(token: $token) {
        getVitalElements(partnerCode: $partnerCode) {
          vitalElements
          partnerCode
        }
      }
    }
  `;

  const data = await exec<GetVitalElementsQueryVariables, GetVitalElementsQuery>(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    }
  );

  const vitalElements = data.restUser?.getVitalElements?.[0]?.vitalElements ?? [];
  return vitalElements.filter((tag): tag is string => tag != null);
};
